import React, { useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { Box, Button, Card, Grid, Typography } from '@mui/material';
import { styles } from '../../styles/styles';
import { DecorativeCorner } from "../../common/DecorativeCorner";
import nathicharami from '../../common/nathicharami.jpg';
import {
    StyledTextField,
    StyledButton,
} from "../../common/FormStyles";

const ContactAdmin = () => {
    const [formValues, setFormValues] = useState({
        name: "",
        userId: "",
        email: "",
        mobile: "",
        aboutMe: ""
    });

    const [errors, setErrors] = useState({});

    const handleChange = (field, value) => {
        setFormValues(prev => ({ ...prev, [field]: value }));
        setErrors(prev => ({ ...prev, [field]: "" }));
    };

    const validate = () => {
        let tempErrors = {};

        if (!formValues.name) tempErrors.name = "Name is required";
        if (!formValues.userId) tempErrors.userId = "User ID is required";

        if (!formValues.email) tempErrors.email = "Email is required";
        else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(formValues.email))
            tempErrors.email = "Enter a valid email";

        if (!formValues.mobile) tempErrors.mobile = "Mobile number is required";
        else if (!/^\d{10}$/.test(formValues.mobile))
            tempErrors.mobile = "Enter valid 10-digit number";

        if (!formValues.aboutMe) tempErrors.aboutMe = "About Me is required";

        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };

    const handleSubmit = () => {
        if (validate()) {
            console.log("Valid form submitted:", formValues);
        }
    };

    return (
        <>
            <Box>
                <Header />
            </Box>
            <Box sx={{ marginTop: { xs: "29%", sm: "10%", md: "10%", lg: "10%", xl: "5%" } }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} md={12}>
                        <Box sx={{ position: 'relative' }}>
                            <Box
                                component="img"
                                src={nathicharami}
                                alt="nathicharami"
                                sx={{ width: '100%', height: 900 }}
                            />
                            <Card
                                sx={{
                                    ...styles.Admincard,
                                    boxShadow: 3,
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 2,
                                    width: { xs: '90%', sm: '70%', md: '80%' }
                                }}
                            >
                                <DecorativeCorner sx={{ top: -20, left: -20 }} />
                                <DecorativeCorner sx={{ top: -20, right: -20 }} />
                                <DecorativeCorner sx={{ bottom: -20, right: -20 }} />
                                <DecorativeCorner sx={{ bottom: -20, left: -20 }} />

                                <Typography variant="h4" component="h1" sx={styles.heading}>
                                    Contact Admin Annapurna Marriages
                                </Typography>

                                <Card sx={{ ...styles.aboutCard, boxSizing: "border-box", padding: "30px" }}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                fullWidth
                                                label="Enter Your Name"
                                                value={formValues.name}
                                                onChange={(e) => handleChange("name", e.target.value)}
                                                error={!!errors.name}
                                                helperText={errors.name}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                fullWidth
                                                label="Enter Your Id"
                                                value={formValues.userId}
                                                onChange={(e) => handleChange("userId", e.target.value)}
                                                error={!!errors.userId}
                                                helperText={errors.userId}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                fullWidth
                                                label="Enter Your Email Id"
                                                value={formValues.email}
                                                onChange={(e) => handleChange("email", e.target.value)}
                                                error={!!errors.email}
                                                helperText={errors.email}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                fullWidth
                                                label="Enter Your Mobile Number"
                                                value={formValues.mobile}
                                                onChange={(e) => handleChange("mobile", e.target.value)}
                                                error={!!errors.mobile}
                                                helperText={errors.mobile}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <StyledTextField
                                                fullWidth
                                                label="About Me"
                                                multiline
                                                rows={3}
                                                value={formValues.aboutMe}
                                                onChange={(e) => handleChange("aboutMe", e.target.value)}
                                                error={!!errors.aboutMe}
                                                helperText={errors.aboutMe}
                                            />
                                        </Grid>
                                    </Grid>

                                    <StyledButton
                                        variant="contained"
                                        sx={{ width: "100%", mt: 3, py: "15px" }}
                                        onClick={handleSubmit}
                                    >
                                        Save & Continue
                                    </StyledButton>
                                </Card>
                            </Card>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Footer />
        </>
    );
};
export default ContactAdmin;
